<template>
  <div class="c-menu-dropdown me-3">
    <label
      for="shop-cart"
      class="c-menu-dropdown__selector"
      @mouseover="blockMenu(true)"
      @mouseleave="blockMenu(false)"
    >
      <span>
        <Icon icon="ant-design:shopping-cart-outlined" />
      </span>
      <span v-if="shopCart.cart.length" class="c-menu-dropdown__number">
        {{shopCart.cart.length}}
      </span>
    </label>
    <input
      type="checkbox"
      id="shop-cart"
      class="d-none"
      v-model="switcher"
    />
    <div
      @mouseover="blockMenu(true)"
      @mouseleave="blockMenu(false)"
      class="c-dropdown-container"
    >
      <div v-if="shopCart.cart.length" class="d-flex flex-column">
        <h2 class="sec-medium fs-25 w-sbold">
          Tu carrito de compras
        </h2>
        <p class="sec-medium w-medium fs-16">
          Tienes
          <span class="w-sbold">
            {{shopCart.cart.length}}
            {{shopCart.cart.length ? 'curso' : 'cursos'}}
          </span>
          en tu carrito
        </p>
        <p class="sec-medium w-regular fs-16">
          Total:
          <span class="alert-med w-sbold">
            {{currency}} {{shopCartAmount}}
          </span>
        </p>
        <div class="c-purchases mb-4">
          <div
            v-for="course of shopCart.cart"
            :key="`course-sc-${course.id}`"
            class="c-purchase"
          >
            <div>
              <figure class="c-purchase__figure me-2">
                <img
                  :src="course.thumbnail"
                  :alt="course.title"
                  class="w-100 h-100 of--cover">
              </figure>
            </div>
            <div class="me-2">
              <router-link
                :to="`/curso/${course.slug}`"
                class="c-purchase__title"
              >
                {{course.title}}
              </router-link>
              <div class="fs-14 sec-light w-regular d-flex align-items-center gap-1">
                Por
                <div class="c-specialist-list" >
                  <span
                    v-for="(item, i) of course.specialist" :key="i"
                    v-b-tooltip.hover :title="`${item.user_firstname} ${item.user_lastname}`">
                    <img :src="item.avatar.url" class="w-100 h-100 ">
                  </span>
                </div>
              </div>
              <p class="sec-light w-sbold fs-14">
                <span class="alert-med w-bold">
                  {{course.price.symbol}}
                  {{Number(course.price.current).toFixed(2)}}
                </span>
                {{course.price.symbol}} {{Number(course.price.before).toFixed(2)}}
              </p>
            </div>
            <div>
              <button
                @click="removeItemFromCart({id: course.id})"
                class="border-0 bg-white sec-light"
              >
                <span>
                  <Icon icon="icon-park-outline:delete"/>
                </span>
              </button>
            </div>
          </div>
        </div>
        <div class="c-hr c-hr--extra mb-4"></div>
        <div class="row gx-3 gy-3">
          <div class="col col-12 col-md-6">
            <button
              @click="reset()"
              class="c-button c-button--black-ghost w-100"
            >
              Vaciar carrito
            </button>
          </div>
          <div class="col col-12 col-md-6">
            <a :href="checkoutLink" class="c-button c-button--primary w-100">
              Comprar ahora
            </a>
          </div>
        </div>
      </div>
      <div v-else>
        <h2 class="sec-medium text-center fs-25 w-sbold">
          ¡Oh no!
        </h2>
        <p class="sec-medium fs-16 w-regular text-center">
          Tu carrito está vacío
        </p>
        <router-link
          to="/cursos"
          class="c-button c-button--primary w-100 d-flex justify-content-center"
        >
          Explorar nuestros cursos
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
  data() {
    return {
      switcher: false,
      isActiveMenu: false,
    };
  },
  computed: {
    ...mapState({
      shopCart: (state) => state.shopCart,
    }),

    currency() {
      return this.shopCart.cart.length ? this.shopCart.cart[0].price.symbol : 'US$';
    },

    isLoggedIn() {
      return this.$store.getters.isAuthenticated;
    },
    userData() {
      return this.$store.getters.stateUser;
    },

    shopCartAmount() {
      const amount = this.shopCart.cart.length
        ? this.shopCart.cart.map((pr) => pr.price.current).reduce((pa, pb) => pa + pb)
        : 0;

      return amount.toFixed(2);
    },
    checkoutLink() {
      const ids = this.shopCart.cart.map((pr) => pr.id);

      return `/checkout/course/?ids=${ids.join(',')}`;
    },
  },
  watch: {
    switcher() {
      document.onclick = () => {
        this.unblockMenu();
      };
    },
  },
  methods: {
    ...mapActions(['reset', 'removeItemFromCart']),

    blockMenu(state) {
      if (state) {
        this.isActiveMenu = true;
      } else {
        this.isActiveMenu = false;
      }
    },
    unblockMenu() {
      if (!this.isActiveMenu) {
        this.switcher = false;
      }
    },
  },
};
</script>
